import axios from "./axiosInstance";

export const getAdditiveMetadata = async (vesselId, startDate, endDate) => {
    const res = await axios.get(`/vessels/${vesselId}/additive/metadata?start=${startDate}&end=${endDate}`)
    return res.data.data;
}

export const getAdditiveFuelConsumption = async (vesselId, startDate, endDate) => {
    const res = await axios.get(`/vessels/${vesselId}/additive/fuel-usage?start=${startDate}&end=${endDate}`)
    return res.data.data;
}

export const getAdditiveUsage = async (vesselId, startDate, endDate) => {
    const res = await axios.get(`/vessels/${vesselId}/additive/additive-usage?start=${startDate}&end=${endDate}`)
    return res.data.data;
}

export const getEmissionData = async (vesselId, startDate, endDate) => {
    const res = await axios.get(`/vessels/${vesselId}/additive/additive-emissions?start=${startDate}&end=${endDate}`)
    return res.data.data;
}

export const getEmissionByDate = async (vesselId, startDate, endDate) => {
    const res = await axios.get(`/vessels/${vesselId}/additive/emission-by-date?start=${startDate}&end=${endDate}`)
    return res.data.data;
}

export const getFirstAdditiveUsageDate = async (vesselId) => {
    const response = await axios.get(`/additives/first-usage-date/${vesselId}`);
    return response.data;
};